import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
} from 'react-admin';
import getUuid from 'uuid-by-string';
import { S3ImageInput } from './aws/S3ImageInput';

const transform = (data) => ({
  ...data,
  id: getUuid(`${data.eventId}|${data.email}`),
  shopId: data.shopId || '*',
});

export default (props) => (
  <Create {...props} transform={transform}>
    <SimpleForm
      redirect="show"
      initialValues={{
        order: 0,
      }}
    >
      <TextInput source="eventId" disabled validate={[required()]} />
      <TextInput source="name" />
      <TextInput source="email" validate={[required()]} />
      <S3ImageInput
        source="image"
        accept="image/*"
        multiple={false}
        keyPrefix="brand-image/"
      />
      <NumberInput source="order" />
    </SimpleForm>
  </Create>
);
